import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {TestApiResponse, TestItem, TestPagination} from "../../../types/test/TestSchema";
import {Pagination} from "features/model/types/groups/groupsLessonsSchema";


interface TestTeacherState {
    tests: TestItem[];
    pagination: TestPagination;
    isLoading: boolean;
}

const testsTeacherSlice = createSlice({
    name: "testsTeacher",
    initialState: {
        tests: [],
        pagination: {} as Pagination,
        isLoading: true,
    } as TestTeacherState,
    reducers: {
        setTeacherTests: (state, action: PayloadAction<TestApiResponse>) => {
            const {data} = action.payload;
            state.tests = data.items;
            state.pagination = data.pagination;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
    },
});

export const {setTeacherTests, setLoading} = testsTeacherSlice.actions;
export const testsTeacherReducer = testsTeacherSlice.reducer;